import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class SkladProvider extends BaseApi {
	async CheckForInventuraCreate(id: number | string): Promise<Record<string, any>> {
		return this.fetch(`/${DMS_MODULE}/${NAME}/CheckForInventuraCreate/${id}`);
	}

	async getWorkshopByOrgUnitId(orgUnitId: any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetWorkshopByOrgUnitId?orgUnitId=${orgUnitId}`);
	}
}

export const apiProvider = new SkladProvider(DMS_MODULE, NAME);
